<template>
  <project-detail-layout :tab="2">
    <div class="tab-container">
      <div class="tab-item"
           :class="tabActive === 1 ? 'tab-hover' : ''"
           @click="tabActive = 1"
      >
        {{ $t("project_management.effort.title.overview") }}
      </div>
      <div class="tab-item"
           :class="tabActive === 2 ? 'tab-hover' : ''"
           @click="tabActive = 2"
      >
        {{ $t("project_management.effort.title.member") }}
      </div>
      <div class="tab-item"
           :class="tabActive === 3 ? 'tab-hover' : ''"
           @click="tabActive = 3"
      >
        {{ $t("project_management.effort.title.update_effort") }}
      </div>
    </div>
    <div v-if="tabActive === 1">
      <CalendarEffort @edit-effort="editEffort"/>
    </div>
    <div v-if="tabActive === 2">
        <ProjectEmployees @reset-tab-active="resetTabActive"/>
    </div>
    <div class="effort-container" v-else-if="tabActive === 3">
      <ValidationObserver v-slot="{ handleSubmit }" ref="effortForm">
        <Form @submit.prevent="handleSubmit(onSubmit)">
          <div class="input-field">
            <div class="input-wrapper">
              <div class="label">
                {{ $t("project_management.project_detail.input_label.date") }}
              </div>
              <ValidationProvider
                  :name="$t('project_management.project_detail.input_label.date')"
                  v-slot="{ errors }"
                  rules="required"
                >
                <DatePicker
                  :clearable="false"
                  v-model="current_date"
                  :format="'DD/MM/YYYY'"
                />
                <span class="required">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div
            v-if="effortProjectDetail"
          >
            <div
              class="input-field"
              v-for="item in effortProjectDetail"
              :key="item.employee_id"
            >
              <div class="input-wrapper staff">
                <div class="label">
                  {{
                    $t(
                      "project_management.project_detail.input_label.employee_name"
                    )
                  }}
                </div>
                <input type="text" :value="item.name" disabled />
              </div>
              <div class="input-wrapper type">
                <div class="label">
                  {{ $t("project_management.project_detail.input_label.type") }}
                  (%)
                </div>
                <ValidationProvider
                  name="type"
                  :vid="item.employee_id"
                  rules="required"
                >
                  <multiselect
                    name="type"
                    v-model="item.set_value"
                    :close-on-select="true"
                    :options="fakeTypeList"
                    :searchable="false"
                    :show-labels="false"
                  >
                    <template slot="singleLabel" slot-scope="props">
                      <div v-if="props.option.name">
                        {{ props.option.name }}
                      </div>
                      <div v-else>{{ customTypeValue(item.set_value) }}</div>
                    </template>
                    <template slot="option" slot-scope="props">
                      <div class="option__desc">
                        <span class="option__title">{{ props.option.name }}</span>
                      </div>
                    </template>
                    <template slot="caret" class="arrow">
                      <div class="select_icon">
                        <img
                          src="@/assets/icons/select_icon.svg"
                          class="caret__icon"
                          alt="select2"
                        />
                      </div>
                    </template>
                  </multiselect>
                  <div class="validation_error" v-if="selectErrors[0].error">
                    trường Type yêu cầu
                  </div>
                </ValidationProvider>
              </div>
              <div class="input-wrapper effort">
                <div class="label">
                  {{ $t("project_management.project_detail.input_label.effort") }}
                  (%)
                </div>
                <ValidationProvider
                  v-slot="{ errors }"
                  :name="$t('project_management.project_detail.input_label.effort')"
                  :vid="item.employee_id"
                  rules="max_value:100|min_value:0|required"
                >
                  <input type="number" v-model="item.effort" />
                  <div class="validation_error">{{ errors[0] }}</div>
                </ValidationProvider>
              </div>
            </div>
          </div>
          <div
            v-if="effortProjectDetail.length === 0"
            class="error-notification"
          >
            Ngày không hợp lệ vui lòng chọn ngày trong dự án
          </div>
          <div v-if="effortProjectDetail.length" class="input-field btn_group">
            <button class="confirm-button" type="submit">
              {{ $t("project_management.kickoff.kickoff_button_submit") }}
            </button>
            <button class="cancel-button" type="button" @click="resetTabActive">
              {{ $t("project_management.kickoff.kickoff_button_cancel") }}
            </button>
          </div>
        </Form>
      </ValidationObserver>
    </div>
  </project-detail-layout>
</template>
<script>
import DatePicker from "vue2-datepicker";
import { mapGetters } from "vuex";
import ProjectDetailLayout from "./ProjectDetailLayout.vue";
import CalendarEffort from "./CalendarEffort.vue";
import ProjectEmployees from "./ProjectEmployees.vue";
import { ValidationProvider, ValidationObserver, Form } from "vee-validate";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
// import moment from "moment";

export default {
  components: {
    ProjectDetailLayout,
    ValidationProvider,
    ValidationObserver,
    Form,
    DatePicker,
    Multiselect,
    CalendarEffort,
    ProjectEmployees,
  },
  data() {
    return {
      current_date: new Date(),
      fakeTypeList: [
        { name: "Tạo value", value: 1 },
        { value: 0, name: "Không tạo value" },
      ],
      selectedValue: { name: "Tạo value", value: 1 },
      testSelected: null,
      selectErrors: [{ id: 1, error: false }],
      fakeEffort: [{ effort: 100, employee_id: 100, id: null, name: "" }],
      tabActive: 1,
    };
  },
  async created() {
    // await this.$root.$loading.start();
    this.getEffortAll();
    // await this.$root.$loading.finish();
  },
  computed: {
    ...mapGetters({
      effortProjectDetail: "projectManagement/effortProjectDetail",
    }),
    dateFormat() {
      return this.getDateFormat();
    },
  },
  watch: {
    current_date() {
      this.getEffortAll();
    },
    tabActive(tab) {
      if (tab === 3) {
        this.getEffortAll();
      }
    },
  },
  methods: {
    resetTabActive() {
      this.$store.dispatch("project/showDetail", this.$route.params.id)
      this.tabActive = 1;
    },
    editEffort(date, canEdit = true) {
      if (!canEdit) return;
      this.tabActive = 3;
      this.current_date = new Date(date);
    },

    customTypeValue(value) {
      if (value === 0) {
        return "Không tạo value";
      }
      if (value === 1) {
        return "Tạo value";
      }
      return "";
    },
    zerofill(i) {
      return (i < 10 ? "0" : "") + i;
    },

    async onSubmit() {
      const id = this.$route.params.id;
      let employees = [];
      this.effortProjectDetail.forEach((item) => {
        employees.push({
          effort: item.effort,
          project_employee_id: item.project_employee_id,
          id: item.id,
          set_value: item?.set_value.value ?? item?.set_value,
        });
      });
      const formData = {
        date: this.dateFormat,
        employees,
      };
      const payload = {
        id,
        formData,
      };
      const respone = await this.$store.dispatch(
        "projectManagement/postEffort",
        payload
      );
      if (respone.status == 200) {
        this.$toast(
          "Lưu thành công",
          "Thành công",
          2000,
          "b-toaster-top-center",
          "success"
        );
        this.resetTabActive()
      }
    },
    async getEffortAll() {
      // await this.$root.$loading.start();
      const id = this.$route.params.id;
      this.$store.dispatch("projectManagement/getEffort", {
        id,
        date: this.dateFormat,
      });
      // await this.$root.$loading.finish();
    },
    getDateFormat() {
      const year = this.current_date.getFullYear();
      const month = this.zerofill(this.current_date.getMonth() + 1);
      const day = this.zerofill(this.current_date.getDate());
      return `${year}-${month}-${day}`;
    }
  },
};
</script>
<style lang="scss" scoped>
.required {
  color: red;
}
.tab-container {
  display: flex;
  margin: 0 30px 20px 30px;
  .tab-item {
    width: fit-content;
    font-size: 14px;
    color: #B3B3B3;
    margin-right: 15px;
  }
  .tab-item:hover {
    cursor: pointer;
  }
  .tab-hover {
    font-size: 14px;
    color: #303c54;
    border-bottom: solid #3488EB 4px;
    font-weight: 500;
  }
}
.effort-container {
  max-width: 562px;
  margin: 0 auto;
  padding: 0 30px;

  form {
    .input-field {
      display: flex;

      .input-wrapper {
        font-family: "Roboto";
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        width: 100%;

        .label {
          font-weight: 600;
          font-size: 14px;
          color: #303c54;
          margin-bottom: 8px;
        }

        input {
          background: #ffffff;
          border: 1px solid #cfcfcf;
          border-radius: 5px;
          height: 40px;
          padding: 10px;
          width: 100%;

          &:focus {
            color: #768192;
            background-color: #fff;
            border-color: #958bef;
            outline: 0;
          }
          &:disabled {
            opacity: .65;
          }
        }
        .validation_error {
          font-size: 12px;
          color: red;
        }
        .mx-datepicker {
          width: 100%;
          height: 40px;
          input {
            height: 40px;
          }
        }
        /deep/ .multiselect__tags {
          height: 40px;
          border: 1px solid #cfcfcf;
        }

        &.staff {
          // width: 60%;
          flex: 1 1 37.5%;
          margin-right: 12px;
        }

        &.type {
          // width: 60%;
          flex: 1 1 37.5%;
          margin-right: 12px;
        }

        &.effort {
          flex: 1 1 25%;
        }
        .select_icon {
          position: absolute;
          width: 40px;
          height: 38px;
          right: 1px;
          top: 1px;
          padding: 4px 8px;
          text-align: center;
          transition: transform 0.2s ease;
        }
        .multiselect--active .select_icon img {
          transform: rotate(180deg);
        }
      }

      &.btn_group {
        display: flex;
        justify-content: center;

        button {
          width: 172px;
          height: 49px;
          border: 1px solid #6e7a8b;
          border-radius: 5px;
          font-family: "Helvetica Neue", sans-serif;
          font-style: normal;
          font-weight: 500;
          font-size: 14px;
          line-height: 17px;
          text-align: center;
          margin-left: 10px;
        }
        .confirm-button {
          background: #118fa6;
          color: #ebf3f4;
        }

        .cancel-button {
          background: #ffffff;
          color: #1f2d3d;
        }
      }
    }
    .error-notification {
      text-align: center;
      color: red;
    }
  }
}
</style>
